import * as React from "react";
import { $, merge } from "glamor";
import theme from "styles/theme";
import debounce from "lodash/debounce";
import Dropdown from "./search-dropdown";
import { formatMessage } from "lib/globalize-util";
import { DATATEST } from "constants/integration";
import * as Immutable from "immutable";

interface IProps {
    onAdd: any;
    onChangeSearchTerm: any;
    onDelete?: any;
    searchTerm: string;
    onFetchContacts: (search?: string) => void;
    users: any;
    userEntities: any;
    selectedContacts: Immutable.List<any>;
}

export class ContactSearch extends React.PureComponent<IProps, any> {
    private search;

    private styles = {
        base: {
            flexGrow: 1,
        },
        hint: {
            bottom: "-2px",
            overflow: "hidden",
            padding: "10px 16px 10px 16px",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "90%",
        },
        input: {
            border: "none",
            fontSize: "16px",
            height: "40px",
            paddingLeft: "16px",
            width: "100%",
        },
        textField: {
            width: "100%",
        },
    };

    private style = merge(
        {
            flexGrow: 1,
            position: "relative",
        },
        $(" .contactSearch", {
            border: "none",
        }),
        $(" .contactResults", {
            border: `1px solid ${theme.palette.borderColor}`,
            borderRadius: "4px",
        }),
        $(" .chips", {
            display: "flex",
            flexWrap: "wrap",
        }),
        $(" .searchInput", {
            border: "none",
            width: "100%",
        })
    );

    constructor(props) {
        super(props);

        this.handleTextFieldChange = debounce(this.handleTextFieldChange, 500);
    }

    UNSAFE_componentWillMount() {
        document.addEventListener("mousedown", this.handleMouseDown);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleMouseDown);
    }

    handleMouseDown = (e) => {
        if (this.findClassRecursively(e.target)) {
            this.props.onChangeSearchTerm();
        }
    };

    findClassRecursively = (el) => {
        const classes = el.classList ? Array.prototype.slice.call(el.classList) : [];
        const isClass = classes.includes("assortmentDialog");
        if (isClass) {
            return true;
        }

        if (!el.parentNode || classes.includes("dropDownOpen") || classes.includes("contactSearch")) {
            return false;
        }

        return this.findClassRecursively(el.parentNode);
    };

    handleNativeInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.handleTextFieldChange(e.target.value);
    };

    handleTextFieldChange = (value) => {
        const { onChangeSearchTerm } = this.props;
        onChangeSearchTerm(value);
        this.props.onFetchContacts(value);
    };

    handleAdd = (user, event) => {
        const { onChangeSearchTerm } = this.props;
        onChangeSearchTerm();
        this.props.onAdd(user);
        this.focus();
    };

    focus = () => {
        this.search.querySelector("input[type=text]").focus();
        this.search.querySelector("input[type=text]").value = "";
    };

    setRef = (ref) => {
        this.search = ref;
    };

    render() {
        const { searchTerm, onFetchContacts, users, userEntities, onChangeSearchTerm, selectedContacts } = this.props;

        return (
            <div {...this.style} className="assortmentDialog" ref={this.setRef}>
                <div className="contactResults">
                    {selectedContacts.size > 0 && <div className="chips">{selectedContacts}</div>}
                    <input
                        data-test={DATATEST.ASSORTMENTS.SHARE_CONTACT_SEARCH}
                        className="searchInput"
                        type="text"
                        placeholder={
                            selectedContacts.size > 0
                                ? formatMessage("Add more...")
                                : formatMessage("Search for recipients")
                        }
                        onChange={this.handleNativeInputChange}
                    />
                </div>
                <Dropdown
                    searchTerm={searchTerm}
                    onAdd={this.handleAdd}
                    onFetchContacts={onFetchContacts}
                    users={users}
                    userEntities={userEntities}
                    onChangeSearchTerm={onChangeSearchTerm}
                    inputRef={this.search}
                />
            </div>
        );
    }
}
